import { apiGet } from '../../composables/apiGet'
import type { ChatMessage, TranscriptResponse } from './types'

// Single-session reads the agent store composes into openSession /
// reloadSession. Both are best-effort and never throw.

// Fetch single-thread status from the server (running state + metadata).
// Best-effort: returns null on failure so callers degrade gracefully.
export async function fetchThreadStatus(
  threadId: string,
): Promise<{ thread_id: string; running: boolean; name: string | null; repo: string } | null> {
  return apiGet(`/api/v1/agent/sessions/${encodeURIComponent(threadId)}`, {
    failureLabel: `Failed to get status for ${threadId}`,
    onError: () => {},
  })
}

// Fetch a session's persisted transcript. Best-effort: returns null on any
// failure so live output still works without history.
export async function fetchTranscript(threadId: string): Promise<ChatMessage[] | null> {
  const res = await apiGet<TranscriptResponse>(`/api/v1/agent/sessions/${encodeURIComponent(threadId)}/messages`, {
    failureLabel: `Failed to load transcript for ${threadId}`,
    onError: () => {},
  })
  return res?.messages ?? null
}
